import fetch from 'isomorphic-fetch';
import { API } from '../../config';

export const getAllTemplates = async () => {
  try {
    const response = await fetch(`${API}/templates`, {
      method: 'GET',
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};
export const getSingleTemplate = async (id) => {
  try {
    const response = await fetch(`${API}/template/${id}`, {
      method: 'GET',
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};

